import FooterLayout from "../Components/FooterLayout";
import { TbCurrencyRupee } from "react-icons/tb";
import { TfiLocationPin } from "react-icons/tfi";
import { TiLocationArrowOutline } from "react-icons/ti";
import { LuGraduationCap } from "react-icons/lu";
import { MdOutlineWorkOutline } from "react-icons/md";
import { HiOutlineCalendarDays } from "react-icons/hi2";
import editIcon from "../Assets/Icons/edit.svg";
import { Image, Popconfirm, Radio, Space } from "antd";
import { Progress, Modal, Spin } from "antd";
import { InboxOutlined, PushpinTwoTone } from "@ant-design/icons";
import { message, Upload } from "antd";
import { CgCalendarDates } from "react-icons/cg";
import bloodIcon from "../Assets/Icons/blood.svg";
import ringIcon from "../Assets/Icons/ring.svg";
import officeIcon from "../Assets/Icons/officeIcon.svg";
import languageIcon from "../Assets/Icons/languageIcon.svg";
import nationalityIcon from "../Assets/Icons/natinality.svg";
import dotIcon from "../Assets/Icons/dotIcon.svg";
import { MdOutlineMail } from "react-icons/md";
import { MdPhoneIphone } from "react-icons/md";
import { useEffect, useState, useRef } from "react";
import CandodateService from "../Service.js/CandidateService";
import iconUploadResumes from "../Assets/Icons/iconUploadResumes.svg";
import ContactDetails from "./CandidateProfileDetails/ContactDetails";
import BasicDetails from "./CandidateProfileDetails/BasicDetails";
import AddExperience from "./CandidateProfileDetails/AddExperience";
import AddProject from "./CandidateProfileDetails/AddProject";
import Config from "../Service.js/config";
import authHeader from "../Service.js/authHeader";
import { isEmpty } from "lodash";
import Empty from "../Components/CommonCommponents/Empty";
import AddEducation from "./CandidateProfileDetails/AddEducation";
import AddCertification from "./CandidateProfileDetails/AddCertification";
import Skill from "./CandidateProfileDetails/Skill";
import downloadIcon from "../Assets/Icons/downlaod.svg";
import AboutMe from "./CandidateProfileDetails/AboutMe";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import { Button } from "antd";
import playIcon from "../Assets/Icons/playButton.svg";
import DocumentUpload from "./documentUpload";
import {
  BarsOutlined,
  AppstoreOutlined,
  PlusCircleOutlined,
  MinusCircleOutlined,
  LoadingOutlined,
  PlusOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { TbDisabled } from "react-icons/tb";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { AiOutlineDelete } from "react-icons/ai";
import deleteIcon from "../Assets/Icons/delete.svg";
import lockIcon from "../Assets/Icons/lockIcon.svg";
import {
  useDeleteChosenDocument,
  useFetchCandidateDocuments,
} from "../ServiceHooks/candidateHooks";
import { getFileType } from "../Utils/utils";
import confirmIcon from "../Assets/Icons/confirmSheet.png";
import { DEFAULT_ERROR_MESSAGE } from "../Utils/constants";
import { Document, Page } from "react-pdf";
import DocumentViewer from "../Components/CommonCommponents/DocumentViewer";
import { Avatar } from "antd";
import AuthService from "../Service.js/authService";
import HireHubHeader from "./HireHubHeader";

dayjs.extend(customParseFormat);

const CandidateProfile = () => {
  const imageUploadRef = useRef();
  const currentUser = JSON.parse(localStorage.getItem("candidate"));
  const [details, setDetails] = useState();
  const [resumeDetails, setResumeDetails] = useState();
  const [allResumeDetails, setAllResumeDetails] = useState();
  const [experienceDetails, setExperienceDetails] = useState();
  const [projectDetails, setProjectDetails] = useState();
  const [educatinalDetails, setEducationDetails] = useState();
  const [certificationDetails, setCertificationDetails] = useState();
  const [isContactInfo, setIscontactInfo] = useState(false);
  const [isEducation, setIsEducation] = useState(false);
  const [contactDetails, setContactDetails] = useState();
  const [isBasicDetails, setIsBasicDetails] = useState();
  const [isExperience, setIsExperience] = useState(false);
  const [profileInfo, setProfileInfo] = useState();
  const [isProject, setIsProject] = useState(false);
  const [isEditProject, setIsEditProject] = useState(false);
  const [isCertification, setIsCertification] = useState(false);
  const [experienceId, setExperienceId] = useState();
  const [projectId, setProjectId] = useState();
  const [educationId, setEducationId] = useState();
  const [certificationId, setCertificationId] = useState();
  const [skillDetails, setSkillDetails] = useState();
  const [isSkill, setIsSkill] = useState(false);
  const [candidateDetails, setCandidateDetails] = useState();
  const [isCandidate, setIsCandidate] = useState(false);
  const [isVideoDetails, setIsVideoDetails] = useState();
  const [profileDetails, setProfileDetails] = useState();
  const [isProfile, setIsProfile] = useState(false);
  const [fileName, setFileNmae] = useState();
  const [isDocsOpen, setDocsOpen] = useState(false);
  const noDataMessage = "Not Mentioned";
  const [loading, setLoading] = useState(false);
  const [isResumeLoading, setResumeLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState();
  const [isSkillUpdated, setSkillUpdate] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [pageNumber, setPageNumber] = useState(0);
  const [checkedItems, setCheckedItems] = useState([]);
  const [isViewDocumentModalOpen, setViewDocumentModal] = useState(false);
  const [isConfirmDocumentModalOpen, setIsConfirmDocumentModalOpen] =
    useState(false);
  const toggleViewDocumentModal = () => setViewDocumentModal((prev) => !prev);
  const toggleConfirmDocumentModal = () =>
    setIsConfirmDocumentModalOpen((prev) => !prev);
  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  };

  const [messageApi, contextHolder] = message.useMessage();
  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG file!");
    }
    const isLt2M = file.size / 1024 / 1024 < 3;
    if (!isLt2M) {
      message.error("Image must smaller than 3MB!");
    }
    return isJpgOrPng && isLt2M;
  };
  const contentStyle = {
    padding: 50,
    borderRadius: 4,
  };

  const content = <div style={contentStyle} />;
  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type="button"
    >
      {loading ? (
        <LoadingOutlined />
      ) : (
        <Avatar
          // shape="square"
          //className="bg-slate-400"
          size={90}
          icon={<UserOutlined />}
        />
      )}
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </button>
  );
  // const educations = jobInfoData?.education_details?.map(obj => obj);

  // const certification = jobInfoData?.certification.map(obj => obj);
  // const nationality = jobInfoData?.nationality.map(obj => obj);
  console.log(resumeDetails, "resumeDetails");
  console.log(details, "resumeDetails");
  const { Dragger } = Upload;
  const props = {
    name: "resume",
    accept: ".doc,.docx,.rtf,.pdf",
    multiple: false, // Assuming single file upload for resume
    authHeader: false,
    showUploadList: false,
    beforeUpload: (file) => {
      // Prevent automatic upload
      setSelectedFile(file);
      return false; // Prevent default upload action
    },
  };
  const resumeUpload = async () => {
    if (selectedFile == null) {
      toast.error("Please Upload your Resume");
    } else {
      setResumeLoading(true);
      await CandodateService.updateReumeUpload(selectedFile)
        .then((response) => {
          if (response.data.success == true) {
            setResumeLoading(false);
            toast.success("Sucessfully Uploded");
            resumeInfo();
            getCandidateSkillInfo();
            getProfilePicture();
            projectInfo();
            experienceinfo();
            educationInfo();
            certificationInfo();
            candidateInfo();
          }
        })
        .catch((error) => {
          console.log("error", error);
          setResumeLoading(false);
          toast.error("Failed To Uploads");
        });
    }
  };
  const upadateProps = {
    name: "profile_picture",
    action:
      Config.API_URL +
      `api/v1/candidates/my-profile-picture/${profileDetails?.id}/`,
    method: "put",
    headers: authHeader(),
    onChange(info) {
      if (info.file.status === "uploading") {
        setLoading(true);
        return;
      }
      if (info.file.status === "done") {
        // Get this url from response in real world.
        getBase64(info.file.originFileObj, (url) => {
          setLoading(false);
          message.success("Profile uploaded successfully");
          getProfilePicture();
        });
      } else if (info.file.status === "error") {
        message.error("Failed To Upload");
      }
    },
  };
  const createDownloadLink = (url, filename) => {
    console.log("url",);
    
    const link = document.createElement("a");
    link.href = url;
    if (filename) {
      link.download = filename;
    }
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
  };
  const updateProfileImage = async (fileName) => {
    await CandodateService.updateProfilePicture(fileName, profileDetails.id)
      .then(
        (oResponse) => {
          console.log("oResponse", oResponse);
          toast.success("Successfully Added!");
          setIsProfile(false);
        },
        (error) => {
          console.log("loginError", error);
        }
      )
      .catch((err) => {
        console.log(err);
        toast.error("Failed To Add");
      });
  };
  const handleFile = (e) => {
    console.log("tedte", e.target.files[0]);

    updateProfileImage(e.target.files[0]);
  };
  const handleClick = (event) => {
    imageUploadRef.current.click();
  };
  const resumeView = (resume, fileName) => {
    console.log("resumeDetails", resumeDetails?.resume_url);
    
    createDownloadLink(resume,fileName);
  };
  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };
  const experienceinfo = async () => {
    await CandodateService.getExperienceDetails()
      .then((response) => {
        console.log("response", response.data.data);
        setExperienceDetails(response.data.data);
      })
      .catch((error) => {});
  };
  const projectInfo = async () => {
    await CandodateService.getProjectDetails()
      .then((response) => {
        console.log("response", response.data.data);
        setProjectDetails(response.data.data);
      })
      .catch((error) => {});
  };
  const educationInfo = async () => {
    await CandodateService.getEducationDetails()
      .then((response) => {
        console.log("response", response.data.data);
        setEducationDetails(response.data.data);
      })
      .catch((error) => {});
  };
  const certificationInfo = async () => {
    await CandodateService.getCertificationDetails()
      .then((response) => {
        console.log("response", response.data.data);
        setCertificationDetails(response.data.data);
      })
      .catch((error) => {});
  };

  const { data: documents, refetch: refetchDocuments } =
    useFetchCandidateDocuments({
      params: {
        candidate_id: contactDetails?.candidate_details_id,
      },
      enabled: !!contactDetails?.candidate_details_id,
    });

  const { mutate: deleteDocument } = useDeleteChosenDocument({
    onSuccess: refetchDocuments,
    onError: async () => {
      await messageApi.open({
        type: "error",
        content: DEFAULT_ERROR_MESSAGE,
      });
    },
  });

  const handleSelectFiles = (e, itemId) => {
    setCheckedItems((prevItems) => {
      if (e.target.checked) {
        // If checkbox is checked, add the item ID to the array
        return [...prevItems, itemId];
      } else {
        // If checkbox is unchecked, remove the item ID from the array
        return prevItems.filter((id) => id !== itemId);
      }
    });
  };

  const handleConfirm = async () => {
    try {
      await CandodateService.confirmDocument(checkedItems);
      await messageApi.open({
        type: "success",
        content: "Successfully Document is Confirmed!",
      });
      refetchDocuments();
      setCheckedItems([]);
      toggleConfirmDocumentModal();
    } catch (error) {
      await messageApi.open({
        type: "error",
        content: "Failed To Add",
      });
    }
  };

  const handleDeleteDocument = (id) => {
    const variables = {
      id,
      params: {
        candidate_id: contactDetails?.candidate_details_id,
      },
    };
    deleteDocument(variables);
  };

  const contactInfo = async () => {
    await CandodateService.candidateContactDetails()
      .then((response) => {
        console.log("response", response.data.data);
        setContactDetails(response.data.data);
      })
      .catch((error) => {});
  };
  const resumeInfo = async () => {
    // await CandodateService.getResumeDetails()
    await CandodateService.getMultiResumeDetails()
      .then((response) => {
        console.log("responseresume", response.data.data);
        let resumes = response.data.data?.results;
        let current_resume = resumes?.filter(
          (item) => item?.is_current_resume === true
        );
        if (current_resume?.length) {
          setResumeDetails(current_resume[0]);
        }
        if (resumes?.length) {
          setAllResumeDetails(resumes);
        } else {
          setAllResumeDetails([]);
        }
      })
      .catch((error) => {});
  };
  console.log("reumess", resumeDetails);
  const getProfileInfo = async () => {
    await CandodateService.candidateProfileCompletion()
      .then((response) => {
        console.log("response", response.data.data);
        setProfileInfo(response.data.data.data);
      })
      .catch((error) => {});
  };
  const candidateInfo = async () => {
    await CandodateService.candidateDetails()
      .then((response) => {
        setDetails(response.data.data);
      })
      .catch((error) => {});
  };
  console.log("detailssccccccc", details);
  const getCandidateSkillInfo = async () => {
    await CandodateService.getCandidateSkill()
      .then((response) => {
        console.log("response", response.data.data);
        setSkillDetails(response.data.data);
      })
      .catch((error) => {});
  };
  const getCandidatePersonalDetails = async () => {
    await CandodateService.getAboutMeDetails()
      .then((response) => {
        console.log("response", response.data.data);
        setCandidateDetails(response.data.data);
      })
      .catch((error) => {});
  };
  const recorderedVideo = async () => {
    await CandodateService.getRecordedDetails()
      .then((response) => {
        console.log("response", response.data.data);
        setIsVideoDetails(response.data.data);
      })
      .catch((error) => {});
  };
  const getProfilePicture = async () => {
    await CandodateService.getProfilePicture()
      .then((response) => {
        console.log("response", response.data.data);
        setProfileDetails(response.data.data);
      })
      .catch((error) => {});
  };

  useEffect(() => {
    contactInfo();
  }, [isContactInfo]);

  useEffect(() => {
    candidateInfo();
    resumeInfo();
    getCandidateSkillInfo();
    getProfileInfo();
    getCandidatePersonalDetails();
    recorderedVideo();
    getProfilePicture();
  }, [isCandidate, isBasicDetails]);

  useEffect(() => {
    if (isSkillUpdated) {
      getCandidateSkillInfo();
    }
  }, [isSkillUpdated]);

  useEffect(() => {
    experienceinfo();
    projectInfo();
    educationInfo();
    certificationInfo();
  }, [isExperience, isProject, isEducation, isCertification]);

  console.log("rsumes", experienceDetails);
  const handleContactInfo = () => {
    console.log("swdef");
    setIscontactInfo(true);
  };
  const handleBasicInfo = () => {
    setIsBasicDetails(true);
    setExperienceId("");
  };
  const handleExperience = () => {
    setIsExperience(true);
    setExperienceId("");
  };
  const handleEditExperience = (id) => {
    console.log("idlog", id);
    setIsExperience(true);
    setExperienceId(id);
  };
  const handleAddProject = () => {
    setIsProject(true);
    setProjectId("");
  };
  const handldeEditProject = (id) => {
    setIsProject(true);
    setProjectId(id);
  };
  const handleEducation = () => {
    setIsEducation(true);
    setEducationId("");
  };
  const handleEditEducation = (id) => {
    setIsEducation(true);
    setEducationId(id);
  };
  const handleCertification = () => {
    setIsCertification(true);
    setCertificationId("");
  };
  const handleEditCertification = (id) => {
    setIsCertification(true);
    setCertificationId(id);
  };
  const handleDocuments = () => {
    setDocsOpen(true);
  };
  const handleSkills = () => {
    setIsSkill(true);
  };

  const handleData = () => {
    setIsCandidate(true);
  };

  const updateCurrentResume = async (id, checked) => {
    const formData = new FormData();
    formData.append("is_current_resume", checked);
    await CandodateService.updateResumeDetails(id, formData)
      .then((response) => {
        console.log("responseresume", response.data);
        if (response.data?.success) {
          resumeInfo();
        }
      })
      .catch((error) => {});
  };

  const handleResumeRemove = async (id) => {
    await CandodateService.removeResume(id)
      .then((response) => {
        console.log("logresume", response);
        resumeInfo();
      })
      .catch((err) => {
        console.log(err);
        toast.error("Failed To Delete");
      });
  };

  const handleViewSelectedFile = (item) => {
    setSelectedFile(item);
    toggleViewDocumentModal();
  };

  const onDocumentLoadSuccess = ({ numPages }) => {
    // setNumPages(numPages);
    setPageNumber(1);
  };

  const fileType = getFileType(selectedFile?.document_absolute_url);

  const formattedDate =
    resumeDetails?.updated != null ? resumeDetails?.updated?.split("T")[0] : "";
  const formattedContactDetails = contactDetails?.updated.split("T")[0];
  const resumeName = resumeDetails?.resume?.split("/");
  const resume = resumeName?.pop();
  console.log("experienceDetails", allResumeDetails);
  const educations = details?.qualifications?.map((obj) => obj);
  const fullName = `${contactDetails?.first_name} ${contactDetails?.last_name}`;
  const Languages = details?.languages?.map((item) =>
    capitalizeFirstLetter(item?.language__language)
  );
  return (
    <>
      <div className="pageContent w-full scrollbar-hide overflow-x-auto">
        {isResumeLoading ? (
          <div className="flex flexwrap justify-center items-center pt-60 pb-60">
            <Spin tip="Uploading Please Wait" size="large">
              {content}
            </Spin>
          </div>
        ) : (
          <div>
            <div className="chart_div">
              <div className="flex items-center justify-end w-full lg:w-[72%]">
                  {currentUser === null ? (
                    <Link
                      to="/login"
                      className="border border-blue-500 text-sm md:text-base px-3 md:px-5 py-1.5 md:py-2 rounded-md hover:text-white hover:bg-[#0071DC] transition duration-300 text-center mr-5 md:mr-0"
                    >
                      Sign In
                    </Link>
                  ) : (
                    <HireHubHeader />
                  )}
                </div>
              <div className="w-full xl:w-3/4 2xl:w-3/4 lg:w-3/4 md:w-full min-w-0">
                <div className="md:flex md:flex-row flex-col md:h-full mt-4 mb-28 gap-6">
                  <div className="w-full md:w-2/6 lg:w-3/6 1xl:w-3/6 xs-xl:w-3/6 2xl:w-2/6 h-full px-4 sm:px-6 md:pl-10 md:pr-0 min-w-0">
                    <div className="md:px-8 px-0">
                      <div className="relative">
                        <div className="">
                          <Upload
                            {...upadateProps}
                            type="file"
                            listType=""
                            width={300}
                            className="rounded-3xl"
                            showUploadList={false}
                            beforeUpload={beforeUpload}
                            capture="environment" // onChange={handleChange}
                          >
                            {profileDetails?.profile_picture_absolute_url ===
                            false ? (
                              uploadButton
                            ) : (
                              <img
                                src={
                                  profileDetails?.profile_picture_absolute_url
                                }
                                alt="avatacvr"
                                style={{
                                  width: "100%",
                                  borderRadius: "21px",
                                }}
                              />
                            )}
                            {/* {
                                                profileDetails?.profile_picture_absolute_url != null ?
                                                (
                                                    <img
                                                    src={profileDetails?.profile_picture_absolute_url}
                                                    alt="avatar"
                                                    style={{
                                                        width: '100%',
                                                        borderRadius: '21px'
                                                    }}
                                                    />
                                                )
                                                :(

                                                    uploadButton
                                                )
                                                } */}
                          </Upload>
                          {/* <Image
                                                width={200}
                                                height={200}
                                                className="rounded-3xl"
                                                src={profileDetails?.profile_picture_absolute_url}
                                                preview={{
                                                    toolbarRender: (
                                                        _,
                                                        {
                                                            transform: { scale },
                                                            actions: { onFlipY, onFlipX, onRotateLeft, onRotateRight, onZoomOut, onZoomIn },
                                                        },
                                                    ) => (
                                                        <Space size={12} className="toolbar-wrapper">
                                                            <button>
                                                                <img src={editIcon} onClick={() => setIsProfile(true)} alt="editIcon" className="mr-8" />
                                                            </button>
                                                        </Space>
                                                    ),
                                                }}
                                            /> */}
                        </div>
                        <div className="flex absolute  right-6"></div>
                      </div>
                      <div className="mt-6">
                        <div className="flex flex-wrap justify-between">
                          <p className="text-base font-semibold">{fullName}</p>
                          <button>
                            <img
                              src={editIcon}
                              onClick={handleContactInfo}
                              alt="editIcon"
                              className="mr-8"
                            />
                          </button>
                        </div>
                        <div className="flex flex-wrap">
                          <MdOutlineMail className="mt-3 mr-2" />
                          <p className="text-base font-normal mt-2 break-all">
                            {contactDetails?.email}
                          </p>
                        </div>
                        <div className="flex flex-wrap">
                          <MdPhoneIphone className="mt-3 mr-2" />
                          <p className="text-base font-normal mt-2 break-all">
                            {contactDetails?.mobile_number}
                          </p>
                        </div>
                      </div>
                      <div className="mt-10 mb-10">
                        <p className="text-gray-600 text-base font-normal">
                          Profile Completion
                        </p>
                        <div style={{ width: 200 }}>
                          <Progress
                            percent={profileInfo}
                            size="small"
                            strokeColor={"#1C4980"}
                          />
                        </div>
                        <p className="text-gray-600 text-base font-normal mt-2">
                          Profile last updated :{" "}
                          {formattedContactDetails || noDataMessage}
                        </p>
                      </div>
                      <div className="mt-8">
                        <div className="mt-4 ">
                          <div className="flex flex-wrap justify-between">
                            <p className="text-base font-semibold ">
                              Key Skill
                            </p>
                            <div className="pl-10">
                              <button>
                                <img
                                  src={editIcon}
                                  alt="editIcon"
                                  onClick={handleSkills}
                                />
                              </button>
                            </div>
                          </div>
                          <div className="mt-6 mb-6 flex flex-wrap">
                            {skillDetails?.results.map((item, index) => {
                              return (
                                <div className="rounded-3xl border border-gray-400 p-1 mx-2 mt-2">
                                  <p className="px-2 text-xs font-normal pt-1">
                                    {item.skills}
                                  </p>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="w-full md:w-4/6 lg:w-4/6 1xl:w-5/6 xs-xl:w-5/6 2xl:w-5/6 h-full px-4 sm:px-6 md:px-6 lg:px-0 xl:px-0 2xl:px-0 min-w-0">
                    <div className="rounded-md border border-gray-300 p-3 bg-[#FFF]">
                      <div className="mt-4 px-4">
                        <div className="flex flex-wrap justify-between">
                          <p className="text-base font-semibold ">
                            Basic Information
                          </p>
                          <button>
                            <img
                              src={editIcon}
                              alt="editIcon"
                              onClick={handleBasicInfo}
                            />
                          </button>
                        </div>

                        <div className="mt-4 flex flex-wrap ">
                          <span className="sm:w-1/3 xs:w-full md:w-1/3 flex flex-wrap items-center  ">
                            <button className="flex flex-wrap">
                              <TfiLocationPin
                                className="mr-2 mt-1 contentIcon"
                                title="Current Location"
                              />

                              <p title="Current Location">
                                {" "}
                                {details?.location || noDataMessage}
                              </p>
                            </button>
                          </span>

                          {/* <span className="sm:w-1/3 xs:w-full md:w-1/3 flex flex-wrap items-center xs:mt-4 sm:mt-0">
                            <button className="flex flex-wrap">
                              <TbCurrencyRupee
                                className="mr-2 mt-1 contentIcon"
                                title="Current CTC"
                              />
                             
                            </button>
                          </span> */}

                          <span className="sm:w-1/3 xs:w-full md:w-1/3 flex flex-wrap items-center xs:mt-4 sm:mt-0 ">
                            <button className="flex flex-wrap ">
                              <TbCurrencyRupee
                                className="mr-2  mt-1 contentIcon"
                                title="Current ctc"
                              />

                              <p title="Current ctc">
                                {details?.current_ctc
                                  ? `${details?.current_ctc} (Current)`
                                  : noDataMessage}
                              </p>
                            </button>
                          </span>

                          <span className="sm:w-1/3 xs:w-full md:w-1/3 flex items-center flex-wrap xs:mt-4 sm:mt-0">
                            <button className="flex flex-wrap">
                              <MdOutlineWorkOutline
                                className="mr-2  mt-1 contentIcon"
                                title="Total Experience"
                              />
                              <p title="Total Experience">
                                {details?.total_exp || details?.total_exp == 0
                                  ? `${details?.total_exp} years`
                                  : noDataMessage}
                              </p>
                            </button>
                          </span>
                        </div>

                        <div className="mt-4 flex flex-wrap">
                          <span className="sm:w-1/3 xs:w-full md:w-1/3 flex items-center">
                            <button className="flex flex-wrap">
                              <CgCalendarDates
                                className="mr-2 mt-1 contentIcon"
                                title="DOB"
                              />
                              <p title="DOB">
                                {details?.dob
                                  ? dayjs(details?.dob, "DD-MM-YYYY").format(
                                      "DD/MM/YYYY"
                                    )
                                  : noDataMessage}
                              </p>
                            </button>
                          </span>
                          <span className="sm:w-1/3 xs:w-full md:w-1/3 flex items-center xs:mt-4 sm:mt-0">
                            <button className="flex flex-wrap">
                              <TbCurrencyRupee
                                className="mr-2 mt-1 contentIcon"
                                title="Expected ctc"
                              />
                              <p title="Expected ctc">
                                {details?.expected_ctc
                                  ? `${details?.expected_ctc} (Expected)`
                                  : noDataMessage}
                              </p>
                            </button>
                          </span>
                          <span className="sm:w-1/3 xs:w-full md:w-1/3 flex flex-wrap xs:mt-4 sm:mt-0">
                            <button className="flex break-all items-center">
                              <img
                                src={languageIcon}
                                alt="languageicon"
                                className="mr-2 mt-1"
                                title="Language Known"
                              />
                              <p title="Language Known">
                                {Languages?.join(",") || noDataMessage}
                              </p>
                            </button>
                          </span>
                          {/* <span className="w-1/3 flex items-center">
                                                <button className="flex flex-wrap">
                                                    <img src={bloodIcon} alt="icons" className="mr-2 mt-1" title="Blood Group" />
                                                    B+
                                                </button>
                                            </span> */}
                        </div>
                        <div className="mt-4 flex flex-wrap ">
                          {/* <span className="flex items-center w-1/3 ">
                                                <button className="flex flex-wrap">
                                                    <LuGraduationCap className="mr-2 mt-1 contentIcon" title="Qualification" />
                                                    {educations?.join(',') || noDataMessage}
                                                </button>
                                            </span> */}

                          <span className="flex items-center sm:w-1/3 xs:w-full md:w-1/3  ">
                            <button className="flex flex-wrap">
                              <HiOutlineCalendarDays
                                className="mr-2 mt-1 contentIcon"
                                title="Notice Period"
                              />
                              <p title="Notice Period">
                                {details?.notice_period || noDataMessage}
                              </p>
                            </button>
                          </span>
                          <span className="sm:w-1/3 xs:w-full md:w-1/3  flex items-center xs:mt-4 sm:mt-0">
                            <button className="flex flex-wrap">
                              <img
                                src={nationalityIcon}
                                alt="nationality"
                                className="mr-3 mt-2"
                                title="Nationality"
                              />
                              <p title="Nationality">
                                {details?.nationality?.nationality ||
                                  noDataMessage}
                              </p>
                            </button>
                          </span>
                          {/* <span className="flex items-center w-1/3 ">
                                                <button className="flex flex-wrap">
                                                    <img src={ringIcon} alt="ringicon" className="mr-2 mt-1" title="Marital status" />
                                                    Single
                                                </button>
                                            </span> */}

                          <span className="sm:w-1/3 xs:w-full md:w-1/3  flex items-center xs:mt-4 sm:mt-0">
                            <button className="flex flex-wrap">
                              <img
                                src={officeIcon}
                                alt="officeicon"
                                className="mr-2 mt-1"
                                title="Preferred Working Condition"
                              />
                              <p title="Preferred Working Condition">
                                {details?.preferred_working_condition_label ||
                                  noDataMessage}
                              </p>
                            </button>
                          </span>
                        </div>
                        {details?.disability === true && (
                          <div className="mt-4 flex flex-wrap ">
                            <span className="flex items-center sm:w-1/3 xs:w-full md:w-1/3 ">
                              <button className="flex flex-wrap">
                                <TbDisabled
                                  className="mr-2 mt-1 contentIcon"
                                  title="Disability"
                                />
                                <p title="Disability">
                                  {details?.disability_type || noDataMessage}
                                </p>
                              </button>
                            </span>
                          </div>
                        )}

                        <div className="h-[1px] bg-[#DEDEDE] mb-6 mt-10"></div>
                        <div className="md:flex md:flex-wrap flex-col md:flex-row gap-6">
                          <div className="w-full xl:w-1/2 2xl:w-1/2 lg:w-full">
                            <p className="text-lg font-semibold mb-6">
                              Resumes
                            </p>
                            {allResumeDetails?.map((res) => (
                              <div>
                                <div className="">
                                  <Radio
                                    checked={res?.is_current_resume}
                                    onChange={(e) =>
                                      updateCurrentResume(
                                        res?.id,
                                        e.target.checked
                                      )
                                    }
                                  >
                                    <p className="text-base font-semibold truncate w-[90%] mb-0">
                                      {res?.display_name || noDataMessage}
                                    </p>
                                  </Radio>
                                </div>
                                <div className="flex justify-between flex-wrap mb-6 items-center">
                                  <p className="text-gray-600 text-base font-normal">
                                    Uploaded on {formattedDate || noDataMessage}
                                  </p>
                                  <div className="flex items-center gap-2">
                                    <Popconfirm
                                      title="Remove Resume"
                                      description="Are you sure to remove this resume?"
                                      onConfirm={() =>
                                        handleResumeRemove(res?.id)
                                      }
                                      // onCancel={cancel}
                                      okText="Yes"
                                      cancelText="No"
                                    >
                                      <button className="p-2 rounded-[50%] bg-[#f1eeee]">
                                        <AiOutlineDelete />
                                      </button>
                                    </Popconfirm>

                                    <button>
                                      <img
                                        src={downloadIcon}
                                        alt="downloadIcon"
                                        onClick={() => resumeView(res?.resume_url,res?.display_name)}
                                      />
                                    </button>
                                  </div>
                                </div>
                              </div>
                            ))}

                            <div className="bg-white mb-10">
                              <Dragger
                                {...props}
                                showUploadList={false}
                                onChange={() => resumeUpload()}
                                //  defaultFileList
                              >
                                <p className="rounded-3xl border border-black bg-white w-full sm:w-1/2 mx-auto mt-4 p-1">
                                  Upload Resume
                                </p>
                                <p className="ant-upload-text pt-4">
                                  Supported Formats: doc, docx, rtf, pdf, upto 2
                                  MB
                                </p>
                              </Dragger>
                            </div>
                            <div className="h-[1px] bg-[#DEDEDE] mb-6"></div>
                          </div>
                          {isVideoDetails?.profile_video_absolute_url ===
                            null ||
                          isVideoDetails?.profile_video_absolute_url ===
                            false ? (
                            <div className="w-full xl:w-1/2 2xl:w-1/2 lg:w-full pl-0 md:pl-6">
                              <div className="bg-white mb-10">
                                <div className="">
                                  <div className="">
                                    <p className="flex flex-wrap justify-center items-center text-base font-semibold pt-6 mb-4">
                                      Profile Video
                                    </p>
                                    <p className="text-teal-600 flex flex-wrap justify-center items-center text-base font-semibold mb-2">
                                      Improve Your Hiring Chances by <br />{" "}
                                    </p>
                                    <p className="text-teal-600 flex flex-wrap justify-center items-center text-base font-semibold mb-6">
                                      {" "}
                                      50% by Adding a Video
                                    </p>
                                  </div>
                                  <div className="flex flex-wrap justify-center items-center pb-4 ">
                                    <div className="">
                                      <Link
                                        to={`/videoRecording/${isVideoDetails?.id}`}
                                        className="px-6"
                                      >
                                        <button className="rounded-3xl border border-black bg-white text-black mt-4 w-full max-w-[220px] mx-auto py-1">
                                          Record Now
                                        </button>
                                      </Link>
                                    </div>

                                    {/* <button className="rounded-3xl border border-black bg-black text-white lg:w-1/2 xl:w-1/3 mt-4 p-1">
                                                                Upload
                                                            </button> */}
                                  </div>
                                  <div className="pb-10">
                                    <p className="text-gray-600 flex flex-wrap justify-center items-center text-base font-semibold px-2 mb-2">
                                      Supported Formats: Mp4, Max size: 225 mb
                                    </p>
                                    <p className="text-gray-600 flex flex-wrap justify-center items-center text-base font-semibold px-2 ">
                                      {" "}
                                      Video Length: 30 sec to 2 min{" "}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div className="w-full xl:w-1/2 2xl:w-1/2 lg:w-full pl-0 md:pl-6">
                              <div>
                                <video
                                  src={
                                    isVideoDetails?.profile_video_absolute_url
                                  }
                                  className="w-full rounded-xl "
                                  style={{ transform: "scaleX(-1)" }}
                                  disablePictureInPicture
                                  controlsList="nodownload nofullscreen noremoteplayback"
                                />
                                {/* <video className="w-full" controls >
                                                                <source src={isVideoDetails?.profile_video_absolute_url} />
                                                                
                                                            </video> */}
                              </div>
                              <div className="h-[50px] w-full rounded-xl bg-[#161616] flex flex-wrap items-center justify-center">
                                <Link to={`/videoPlayer`} className="px-6">
                                  <button>
                                    <img
                                      src={playIcon}
                                      alt="playIcon"
                                      className="w-8"
                                    />
                                  </button>
                                </Link>
                              </div>
                              {/* <div className="flex flex-wrap items-center justify-center mt-4">
                                                            <Link to={`/videoRecording/${isVideoDetails?.id}`} className="px-6">
                                                                <Button
                                                                    className="rounded-full border border-black bg-white text-black text-base">
                                                                    Upload Video
                                                                </Button>
                                                            </Link>
                                                        </div> */}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="rounded-md border border-gray-300 p-3 bg-[#FFF] mt-8">
                      <div className="mt-4 px-4">
                        <div className="flex flex-wrap justify-between">
                          <p className="text-base font-semibold ">About Me</p>
                          <button>
                            <img
                              src={editIcon}
                              alt="editIcon"
                              onClick={handleData}
                            />
                          </button>
                        </div>
                        {!isEmpty(candidateDetails) ? (
                          <div className="">
                            <div className=" mt-5 mb-5">
                              <p
                                className="text-xs font-normal px-4 mt-2 flex flex-wrap"
                                dangerouslySetInnerHTML={{
                                  __html: `${candidateDetails?.about_me}`,
                                }}
                              ></p>
                            </div>
                          </div>
                        ) : (
                          <div className="flex items-center justify-center">
                            <Empty
                              description={<>{<p> No Details Added</p>}</>}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="rounded-md border border-gray-300 p-3 bg-[#FFF] mt-8">
                      <div className="mt-4 px-4">
                        <div className="flex flex-wrap justify-between ">
                          <p className="text-base font-semibold ">Experience</p>

                          <button>
                            <p
                              onClick={handleExperience}
                              className="rounded-3xl border border-black bg-white p-1 px-4"
                            >
                              Add Experience
                            </p>
                          </button>
                        </div>
                        {!isEmpty(experienceDetails?.results) ? (
                          <div className="md:flex md:flex-wrap  md:flex-row flex-col md:[&>*:nth-child(even)]:border-l md:[&>*:nth-child(even)]:px-8 [&>*:nth-child(even)]:border-gray-300 ">
                            {experienceDetails?.results?.map((item, index) => {
                              return (
                                <div className="md:w-1/2 w-full mt-10 mb-10">
                                  <div className="flex flew-wrap justify-between ">
                                    <div className="flex flew-wrap ">
                                      <img
                                        src={dotIcon}
                                        alt="dotIcon"
                                        className="w-2"
                                      />
                                      <p className="text-base font-semibold pl-2">
                                        {item.designation}
                                      </p>
                                    </div>
                                    <button>
                                      <img
                                        onClick={() =>
                                          handleEditExperience(item.id)
                                        }
                                        src={editIcon}
                                        alt="editIcfbon"
                                        className="pl-12 mr-10"
                                      />
                                    </button>
                                  </div>

                                  <p className="px-4 text-base font-semibold mt-2 ">
                                    {item.company}
                                  </p>
                                  <p className="text-gray-600 font-poppins text-xs font-normal px-4 mt-2">
                                    {" "}
                                    {item?.worked_from
                                      ? dayjs(
                                          item?.worked_from,
                                          "YYYY-MM-DD"
                                        ).format("DD/MM/YYYY")
                                      : noDataMessage}{" "}
                                    -{" "}
                                    {item?.worked_till
                                      ? dayjs(
                                          item?.worked_till,
                                          "YYYY-MM-DD"
                                        ).format("DD/MM/YYYY")
                                      : noDataMessage}
                                    {/* {item?.worked_from} - {item?.worked_till} */}
                                  </p>
                                  {item?.experience != null && (
                                    <p
                                      className="text-xs font-normal px-4 mt-2 flex flex-wrap"
                                      dangerouslySetInnerHTML={{
                                        __html: `${item?.experience}`,
                                      }}
                                    ></p>
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        ) : (
                          <div className="flex items-center justify-center">
                            <Empty
                              description={<>{<p> No Experience Added</p>}</>}
                            />
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="rounded-md border border-gray-300 p-3 bg-[#FFF] mt-8">
                      <div className="mt-4 px-4">
                        <div className="flex flex-wrap justify-between ">
                          <p className="text-base font-semibold ">Projects</p>

                          <button>
                            <p
                              onClick={handleAddProject}
                              className="rounded-3xl border border-black bg-white p-1 px-4"
                            >
                              Add Project
                            </p>
                          </button>
                        </div>
                        {!isEmpty(projectDetails?.results) ? (
                          <div className="md:flex md:flex-wrap md:flex-row flex-col md:[&>*:nth-child(even)]:border-l md:[&>*:nth-child(even)]:px-8 [&>*:nth-child(even)]:border-gray-300 ">
                            {projectDetails?.results?.map((item, index) => {
                              return (
                                <div className="md:w-1/2 w-full mt-10 mb-10">
                                  <div className="flex flew-wrap justify-between ">
                                    <div className="flex flew-wrap ">
                                      <img
                                        src={dotIcon}
                                        alt="dotIcon"
                                        className="w-2"
                                      />
                                      <p className="text-base font-semibold pl-2">
                                        {item.project}
                                      </p>
                                    </div>
                                    <button>
                                      <img
                                        onClick={() =>
                                          handldeEditProject(item.id)
                                        }
                                        src={editIcon}
                                        alt="editIcfbon"
                                        className="pl-12 mr-10"
                                      />
                                    </button>
                                  </div>

                                  <p className="px-4 text-base font-semibold mt-2 flex flex-wrap">
                                    {item.company}
                                  </p>
                                  <p className="text-gray-600 font-poppins text-xs font-normal px-4 mt-2">
                                    {" "}
                                    {item?.worked_from
                                      ? dayjs(
                                          item?.worked_from,
                                          "YYYY-MM-DD"
                                        ).format("DD/MM/YYYY")
                                      : noDataMessage}{" "}
                                    -{" "}
                                    {item?.worked_till
                                      ? dayjs(
                                          item?.worked_till,
                                          "YYYY-MM-DD"
                                        ).format("DD/MM/YYYY")
                                      : noDataMessage}
                                    {/* {item?.worked_from} - {item?.worked_till} */}
                                  </p>
                                  {item?.responsibilities && (
                                    <p
                                      className="text-xs font-normal px-4 mt-2 flex flex-wrap"
                                      dangerouslySetInnerHTML={{
                                        __html: `${item?.responsibilities}`,
                                      }}
                                    ></p>
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        ) : (
                          <div className="flex items-center justify-center">
                            <Empty
                              description={<>{<p> No Projects Added</p>}</>}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="rounded-md border border-gray-300 p-3 bg-[#FFF] mt-8">
                      <div className="mt-4 px-4">
                        <div className="flex flex-wrap justify-between ">
                          <p className="text-base font-semibold ">Education</p>

                          <button>
                            <p
                              onClick={handleEducation}
                              className="rounded-3xl border border-black bg-white p-1 px-4"
                            >
                              Add Education
                            </p>
                          </button>
                        </div>

                        {!isEmpty(educatinalDetails?.results) ? (
                          <div className="md:flex md:flex-wrap md:flex-row flex-col md:[&>*:nth-child(even)]:border-l md:[&>*:nth-child(even)]:px-8 [&>*:nth-child(even)]:border-gray-300 ">
                            {educatinalDetails?.results?.map((item, index) => {
                              return (
                                <div className="md:w-1/2 w-full  mt-10 mb-10">
                                  <div className="flex flew-wrap justify-between ">
                                    <div className="flex flew-wrap ">
                                      <img
                                        src={dotIcon}
                                        alt="dotIcon"
                                        className="w-2"
                                      />
                                      <p className="text-base font-semibold pl-2">
                                        {item.qualification_name}
                                      </p>
                                    </div>
                                    <button>
                                      <img
                                        onClick={() =>
                                          handleEditEducation(item.id)
                                        }
                                        src={editIcon}
                                        alt="editIcfbon"
                                        className="pl-12 mr-10"
                                      />
                                    </button>
                                  </div>

                                  <p className="px-4 text-base font-normal mt-2 flex flex-wrap ">
                                    {item.college}
                                  </p>
                                  <p className="text-gray-600 font-poppins text-xs font-normal px-4 mt-2">
                                    {item?.course_start_date
                                      ? dayjs(
                                          item?.course_start_date,
                                          "YYYY-MM-DD"
                                        ).format("DD/MM/YYYY")
                                      : noDataMessage}{" "}
                                    -{" "}
                                    {item?.course_completed_date
                                      ? dayjs(
                                          item?.course_completed_date,
                                          "YYYY-MM-DD"
                                        ).format("DD/MM/YYYY")
                                      : noDataMessage}
                                    {/* {item?.course_start_date} -{" "}
                                {item?.course_completed_date} */}
                                  </p>
                                </div>
                              );
                            })}
                          </div>
                        ) : (
                          <div className="flex items-center justify-center">
                            <Empty
                              description={
                                <>{<p> No Education Details Added</p>}</>
                              }
                            />
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="rounded-md border border-gray-300 p-3 bg-[#FFF] mt-8">
                      <div className="mt-4 px-4">
                        <div className="flex flex-wrap justify-between ">
                          <p className="text-base font-semibold ">
                            Certifications
                          </p>

                          <button>
                            <p
                              onClick={handleCertification}
                              className="rounded-3xl border border-black bg-white p-1 px-4"
                            >
                              Add Certification
                            </p>
                          </button>
                        </div>

                        {!isEmpty(certificationDetails?.results) ? (
                          <div className="md:flex md:flex-wrap md:flex-row flex-col md:[&>*:nth-child(even)]:border-l md:[&>*:nth-child(even)]:px-8 [&>*:nth-child(even)]:border-gray-300 ">
                            {certificationDetails?.results?.map(
                              (item, index) => {
                                return (
                                  <div className="md:w-1/2 w-full mt-10 mb-10">
                                    <div className="flex flew-wrap justify-between ">
                                      <div className="flex flew-wrap ">
                                        <img
                                          src={dotIcon}
                                          alt="dotIcon"
                                          className="w-2"
                                        />
                                        <p className="text-base font-semibold pl-2">
                                          {item.certification_name}
                                        </p>
                                      </div>
                                      <button>
                                        <img
                                          onClick={() =>
                                            handleEditCertification(item.id)
                                          }
                                          src={editIcon}
                                          alt="editIcfbon"
                                          className="pl-12 mr-10 "
                                        />
                                      </button>
                                    </div>

                                    <p className="px-4 text-base font-semibold mt-2 ">
                                      {item.college}
                                    </p>
                                    <p className="text-gray-600 font-poppins text-xs font-normal px-4 mt-2">
                                      {item?.course_start_date
                                        ? dayjs(
                                            item?.course_start_date,
                                            "YYYY-MM-DD"
                                          ).format("DD/MM/YYYY")
                                        : noDataMessage}{" "}
                                      -{" "}
                                      {item?.course_completed_date
                                        ? dayjs(
                                            item?.course_completed_date,
                                            "YYYY-MM-DD"
                                          ).format("DD/MM/YYYY")
                                        : noDataMessage}
                                      {/* {" "}
                                {item?.course_start_date} -{" "}
                                {item?.course_completed_date} */}
                                    </p>
                                  </div>
                                );
                              }
                            )}
                          </div>
                        ) : (
                          <div className="flex items-center justify-center">
                            <Empty
                              description={
                                <>{<p> No Certifications Added</p>}</>
                              }
                            />
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="rounded-md border border-gray-300 p-3 bg-[#FFF] mt-8">
                      <div className="mt-4 px-4">
                        <div className="flex flex-wrap justify-between ">
                          <p className="text-base font-semibold ">
                            My Documents
                          </p>

                          <button>
                            <p
                              onClick={handleDocuments}
                              className="rounded-3xl border border-black bg-white p-1 px-4"
                            >
                              Add Document
                            </p>
                          </button>
                        </div>

                        {!isEmpty(documents?.results) ? (
                          <div className="flex flex-wrap">
                            {documents?.results?.map((item, index) => {
                              const formattedContactDetails =
                                item?.updated.split("T")[0];
                              const documenturl =
                                item?.document_absolute_url.split("/");
                              const uploadeFile =
                                documenturl[documenturl.length - 1];
                              return (
                                <div className="w-full">
                                  <div className="flex flex-wrap justify-between mt-6">
                                    <div className="flex flex-wrap items-center gap-2">
                                      {item.status === "NOT_CONFIRM" && (
                                        <input
                                          id={item.id}
                                          type="checkbox"
                                          className="w-5 bg-[#000]"
                                          onChange={(e) => {
                                            handleSelectFiles(e, item.id);
                                          }}
                                        />
                                      )}
                                      {item.status === "CONFIRM" && (
                                        <img
                                          src={lockIcon}
                                          alt="lockicon"
                                          className="w-4"
                                        />
                                      )}
                                      <div></div>
                                      <p className="pl-6 text-medium font-medium mt-1">
                                        {item?.document_type_readable}
                                      </p>
                                    </div>
                                    <div className="flex flex-wrap items-center gap-2">
                                      {contextHolder}
                                      {item.status === "NOT_CONFIRM" && (
                                        <button
                                          onClick={() =>
                                            handleDeleteDocument(item.id)
                                          }
                                        >
                                          <img
                                            src={deleteIcon}
                                            alt="sefg"
                                            className="pr-6 "
                                          />
                                        </button>
                                      )}

                                      {item.status === "NOT_CONFIRM" && (
                                        <button className="rounded-full bg-[#F19292] px-4 text-white text-medium font-medium leading-normal">
                                          Not Confirm
                                        </button>
                                      )}
                                      {item.status === "CONFIRM" && (
                                        <button className="rounded-full bg-[#53A994] px-4 p-2 text-white text-medium font-medium leading-normal">
                                          Confirmed
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                  <div className="flex flex-col sm:flex-row sm:items-center">
                                    <button
                                      onClick={() =>
                                        handleViewSelectedFile(item)
                                      }
                                      className="pl-0 sm:pl-10 text-left text-gray-600 font-poppins text-base font-normal underline break-all max-w-full"
                                    >
                                      {uploadeFile}
                                    </button>
                                    <p className="hidden sm:block mx-4 divider">|</p>
                                    <p className="text-gray-600 font-poppins text-base font-normal sm:mt-0 mt-1 sm:pl-0 pl-0">
                                      Uploaded on {formattedContactDetails}
                                    </p>
                                  </div>
                                  <div className="h-[1px] bg-[#DEDEDE] w-full mt-8"></div>
                                </div>
                              );
                            })}

                            {checkedItems?.length ? (
                              <div className="w-full flex justify-end mt-10 mb-10">
                                <div className="">
                                  <Button
                                    onClick={() => toggleConfirmDocumentModal()}
                                    className="rounded-full border border-solid border-black text-white bg-[#0A0A0A]"
                                  >
                                    Confirm
                                  </Button>
                                </div>
                              </div>
                            ) : null}
                          </div>
                        ) : (
                          <div className="flex items-center justify-center">
                            <Empty
                              description={<>{<p> No Documents Added</p>}</>}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                    {/* <div className="rounded-md border border-gray-300 p-3 bg-[#F2F8F89E] mt-8" >
                                    <div className="w-1/2 mt-4 px-4">
                                        <div className="flex flex-wrap justify-between">
                                            <p className="text-base font-semibold ">Key Skill</p>
                                            <button>
                                                <img src={editIcon} alt="editIcon" onClick={handleSkills} />
                                            </button>

                                        </div>
                                        <div className="mt-4 mb-4 flex flex-wrap">
                                            {skillDetails?.results.map((item, index) => {
                                                return (
                                                    <div className='rounded-3xl border border-gray-400 p-1 mx-2 mt-2'>
                                                        <p className='px-2 text-xs font-normal pt-1'>{item.skills}</p>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                </div> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-4">{/* <FooterLayout /> */}</div>
          </div>
        )}
      </div>
      {isContactInfo && (
        <Modal
          // className="settingsPage"
          title={"Edit Contact Info"}
          open={isContactInfo}
          width={703}
          onCancel={() => setIscontactInfo(false)}
          footer={null}
        >
          <ContactDetails details={contactDetails} close={setIscontactInfo} />
        </Modal>
      )}
      {isBasicDetails && (
        <Modal
          // className="settingsPage"
          title={"Edit Basic Information"}
          open={isBasicDetails}
          width={750}
          onCancel={() => setIsBasicDetails(false)}
          footer={null}
        >
          <BasicDetails details={details} close={setIsBasicDetails} />
        </Modal>
      )}
      {isExperience && (
        <Modal
          // className="settingsPage"
          title={experienceId ? "Edit Experience" : "Add Experience"}
          open={isExperience}
          experienceDetail={experienceDetails}
          width={703}
          onCancel={() => setIsExperience(false)}
          footer={null}
        >
          <AddExperience
            details={contactDetails}
            experienceId={experienceId}
            close={setIsExperience}
          />
        </Modal>
      )}
      {/* {
                isEditExperience && (
                    <Modal
                        // className="settingsPage"
                        title={"Edit Experience"}
                        open={isEditExperience}
                        width={703}
                        onCancel={() => setIsEditExperience(false)}
                        footer={null}
                    >
                        <AddExperience
                            details={contactDetails}
                            experienceId={experienceId}
                            close={setIsEditExperience} />
                    </Modal >
                )
            } */}
      {isProject && (
        <Modal
          // className="settingsPage"
          title={projectId ? "Edit Projects" : "Add Projects"}
          open={isProject}
          width={703}
          onCancel={() => setIsProject(false)}
          footer={null}
        >
          <AddProject
            details={contactDetails}
            projectId={projectId}
            close={setIsProject}
          />
        </Modal>
      )}
      {/* {
                isEditProject && (
                    <Modal
                        // className="settingsPage"
                        title={"Edit Projects"}
                        open={isEditProject}
                        width={703}
                        onCancel={() => setIsEditProject(false)}
                        footer={null}
                    >
                        <AddProject

                            projectId={projectId}
                            close={setIsEditProject} />
                    </Modal >
                )
            } */}
      {isEducation && (
        <Modal
          // className="settingsPage"
          title={educationId ? "Edit Education" : "Add Education"}
          open={isEducation}
          width={703}
          onCancel={() => setIsEducation(false)}
          footer={null}
        >
          <AddEducation educationId={educationId} close={setIsEducation} />
        </Modal>
      )}
      {isCertification && (
        <Modal
          // className="settingsPage"
          title={certificationId ? "Edit Certification" : "Add Certification"}
          open={isCertification}
          width={703}
          onCancel={() => setIsCertification(false)}
          footer={null}
        >
          <AddCertification
            certificationId={certificationId}
            close={setIsCertification}
          />
        </Modal>
      )}
      {isSkill && (
        <Modal
          // className="settingsPage"
          title={"Edit Skill"}
          open={isSkill}
          width={703}
          onCancel={() => setIsSkill(false)}
          footer={null}
        >
          <Skill
            skillDetails={skillDetails}
            close={setIsSkill}
            setSkillUpdate={setSkillUpdate}
            isSkillUpdated={isSkillUpdated}
          />
        </Modal>
      )}
      {isCandidate && (
        <Modal
          // className="settingsPage"
          title={"About Me"}
          open={isCandidate}
          width={703}
          onCancel={() => setIsCandidate(false)}
          footer={null}
        >
          <AboutMe candidateDetails={candidateDetails} close={setIsCandidate} />
        </Modal>
      )}
      {isProfile && (
        <Modal
          open={isProfile}
          title="Add Candidates"
          footer={null}
          width={700}
          onCancel={() => setIsProfile(false)}
          className="addCandidatesModal"
        >
          <div className="flex justify-center pt-36 pb-36">
            <>
              <label
                for="Upload image"
                className="uploadItem w-64 py-5 px-6 uploadGrid flex flex-col justify-center items-center border border-dashed divide-dashed text-center border-slate-300 min-w-14 hover:border-cyan-500 rounded-md cursor-pointer"
              >
                <img
                  src={iconUploadResumes}
                  alt="upload resumes"
                  onClick={handleClick}
                  className="mb-4 h-auto w-12"
                />
                <div className="uploadText">
                  <p className="font-normal text-heading1">Upload Images</p>
                  <p className="text-body3">Upload JPG</p>
                  <input
                    type="file"
                    name="resume"
                    // {...register('resume', {
                    //     required: "This field is required",
                    // })
                    // }
                    //  {...otherLogoFieldItems}
                    //control={control}
                    onChange={handleFile}
                    ref={imageUploadRef}
                    accept=".jpg"
                    style={{ display: "none" }}
                  />
                </div>
              </label>
            </>
          </div>
        </Modal>
      )}
      <Modal
        open={isDocsOpen}
        title="Upload Documents"
        footer={null}
        width={700}
        onCancel={() => setDocsOpen(false)}
        className="addCandidatesModal"
      >
        <DocumentUpload
          candidateId={contactDetails?.candidate_details_id}
          close={() => {
            setDocsOpen(false);
            refetchDocuments();
          }}
        />
      </Modal>
      <Modal
        open={isConfirmDocumentModalOpen}
        title="Upload Documents"
        footer={null}
        width={700}
        onCancel={() => toggleConfirmDocumentModal()}
        className="addCandidatesModal"
      >
        <form>
          <div className="flex flex-wrap items-center justify-center mt-10">
            <div>
              <div className="">
                <img src={confirmIcon} alt="browserWindowIcon" />
              </div>
              <div className="flex flex-wrap items-center justify-center mt-4 px-6">
                <p className="text-black font-poppins text-2xl font-bold">
                  Are you sure?
                </p>
              </div>
              <div className="flex flex-wrap items-center justify-center mt-4 px-6">
                <p className="text-gray-600 text-center font-poppins text-base font-normal">
                  {" "}
                  Are you sure you want to confirm
                  <br />
                  with this document?
                </p>
              </div>
              <div className="flex flex-wrap items-center justify-center mt-16 px-6 mb-16">
                <div className="flex flex-wrap justify-between">
                  <div className="px-6">
                    <Button
                      onClick={() => handleConfirm()}
                      className="text-black rounded-full border border-black font-poppins text-base font-semibold"
                    >
                      Yes
                    </Button>
                  </div>
                  <div>
                    <Button
                      onClick={() => toggleConfirmDocumentModal()}
                      className="rounded-full bg-black text-white font-poppins text-base font-semibold"
                    >
                      No
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </Modal>
      <Modal
        open={isViewDocumentModalOpen}
        title=""
        footer={null}
        width={700}
        onCancel={() => toggleViewDocumentModal()}
        className="addCandidatesModal"
      >
        <div className="flex flex-wrap items-center justify-center mt-10">
          {fileType === "pdf" ? (
            <div className="w-12">
              <Document
                file={selectedFile?.document_absolute_url}
                onLoadSuccess={onDocumentLoadSuccess}
              >
                <Page pageNumber={pageNumber} />
              </Document>
            </div>
          ) : (
            <DocumentViewer
              fileUrl={selectedFile?.document_absolute_url}
              fileType={fileType}
            />
          )}
        </div>
      </Modal>
    </>
  );
};
export default CandidateProfile;
